import { checkCapabilities, CheckCapabilitiesParams } from 'common/auth'
import { useCapabilitiesContext } from 'context'

export type UseCapabilitiesParams = CheckCapabilitiesParams

export default function useCapabilities(params: UseCapabilitiesParams) {
  const capabilitiesContext = useCapabilitiesContext()
  return checkCapabilities(capabilitiesContext, params)
}
